import { Roles, SIGN_IN_ROLES } from '../const/permissions'

export const checkSignInRoles = (roles: Roles[]) => {
  return roles.some((role) => SIGN_IN_ROLES.includes(role))
}
